module.exports = __webpack_public_path__ + "img/doc_job.66872fa6.png";